export const configurationColumnTableStableA = {
  activityDate: true /*required field*/,
  done: true /*required field*/,
  type: true /*required field*/,
  stableNames: true /*required field*/,
  stableBoxNames: true,
  totalAnimals: true,
  productNames: true,
  userNames: true,
  tractorNames: true,
  equipmentNames: true,
  note: true,
};

/* QUESTA è LA CONFIGURAZIONE DI DEFAULT PER LE COLONNE NELLA TABELLA ATTVIITA */

/*
export const ColumnTableActivities = {
  "activityDate": true, --> required field
  "done": true, --> required field
  "type": true, --> required field
  "fieldNames": true, --> required field
  "groupNames": true,
  "commodity": true,
  "productNames": true,
  "userNames": true,
  "tractorNames": true,
  "equipmentNames": true,
  "machineActivities": true,
  "shapeFileTotal": true,
  "files": true,
  "fromDate": false,
  "toDate": false,
  "infestationLevel": false,
  "interventionReason": false,
  //"treatmentType": false,//NOT USE AT THE MOMENT
  "temperature": false,
  "humidity": false,
  "wind": false,
  "rainLast24h": false,
  "fieldTags": false,
  "subunit": false
}
*/
